// extracted by mini-css-extract-plugin
module.exports = {"menuText":"rgba(0,0,0,0.45)","menuActiveText":"#FFA940","subMenuActiveText":"rgba(0,0,0,0.45)","menuBg":"#fff","sideBarWidth":"210px"};